export const FETCH_NEW_ORDERS = 'fetch_new_orders';
export const FETCH_SUBMITTED_ORDERS = 'fetch_submitted_orders';
export const FETCH_ALL_SKUS = 'fetch_all_skus';
export const CHANGE_AUTH = 'change_auth';
export const FETCH_ERROR_MESSAGE = 'fetch_error_message';